import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class VideoService {
    constructor(private api: ApiService) { }

    getVideos(accountId) { 
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.videos + '/getVideos' + '?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteVideo(videoId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.videos + '/delete?videoId=' + videoId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/video.service.ts